import Alpine from "alpinejs";
import Swup from 'swup';
import SwupOverlayTheme from '@swup/overlay-theme';

import intersect from "@alpinejs/intersect";
import animatedNumber from "./components/animatedNumber.js";
import barChart from "./components/barChart.js";
import stackedBarChart from "./components/stackedBarChart.js";
import doughnutChart from "./components/doughnutChart.js";
import animatedNumberPanel from "./components/animatedNumberPanel.js";
import accordion from "./components/accordion.js";
import navigation from "./components/navigation.js";

window.Alpine = Alpine;
Alpine.plugin(intersect);

animatedNumber();
barChart();
stackedBarChart();
doughnutChart();
animatedNumberPanel();
accordion();
navigation();

const swup = new Swup({
    linkSelector: 'a[href="/"]',
    plugins: [
        new SwupOverlayTheme({
            direction: 'to-right',
        }),
    ]
});

if(window.location.pathname === '/') {
    window.onload = () => {
        const html = document.getElementsByTagName('html');
        html[0].classList.add('is-changing')
        html[0].classList.add('is-animating')
        setTimeout(() => {
            html[0].classList.add('is-rendering')

        },1000);
    };
}

window.addEventListener('scroll', () => {
    const isScrolled = window.scrollY > 100;
    document.querySelector('.animateMouse').classList.toggle('opacity-0', isScrolled);
    setTimeout(() => {
        document.querySelector('.animateMouse').classList.toggle('hidden', isScrolled);
    }, 500);
    document.querySelectorAll('.pageNav').forEach(pageNav => {
        pageNav.classList.remove(isScrolled ? 'bg-white' : 'bg-black', isScrolled ? 'text-black' : 'text-white');
        pageNav.classList.add(isScrolled ? 'bg-black' : 'bg-white', isScrolled ? 'text-white' : 'text-black');
    });
});

Alpine.start();